import { NButton, NDialog } from '@innersource-nn/novoui-react';
import React from 'react';
import { ModalProps } from 'types/Modal';

export interface DeleteModalProps extends ModalProps {
    title: string;
    type: string;
    loading?: boolean;
    onClick: VoidFunction;
}

const DeleteModal = ({
    title,
    type,
    loading,
    onClick,
    visible,
    onClose,
}: DeleteModalProps) => {
    return (
        <NDialog
            isVisible={visible}
            closeDialog={onClose}
            backgroundClose
            headline={title}
            size="small"
            showDividers={false}
        >
            <div>
                <div className="py-16 text-true-blue">
                    Are you sure you want to delete this {type}? This action is
                    permanent and cannot be undone.
                </div>
                <div className="flex justify-end items-center gap-16">
                    <NButton variant="outline" square onClick={onClose}>
                        Cancel
                    </NButton>
                    <NButton
                        variant="destructive"
                        square
                        onClick={onClick}
                        isLoading={loading}
                    >
                        Delete permanently
                    </NButton>
                </div>
            </div>
        </NDialog>
    );
};
export default DeleteModal;
